import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { WebinarLink } from './WebinarLink';
export const FAQ = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-69">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-70">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-71">
        Wat moderne wetenschap ons leert
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-72">
        27 recente studies ondersteunen Mech's latere inzichten. Honden zijn
        sociale leerders die bloeien onder:
      </p>
      <ul className="mb-6 list-disc pl-5 space-y-2" data-id="element-73">
        <li data-id="element-74">Duidelijke, liefdevolle communicatie</li>
        <li data-id="element-75">Vertrouwen en samenwerking</li>
        <li data-id="element-76">Begrip van hun natuurlijke signalen</li>
        <li data-id="element-77">
          Handgebaren (99% effectief vs 82% voor stemcommando's)
          <div className="mt-1" data-id="element-78">
            Ontdek het tijdens het webinar.{' '}
            <a href="https://stresslessdogs.nl/meta-mcc-adv" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-79">
              Aanmelden kan hier.
            </a>
          </div>
        </li>
      </ul>
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-80">
        Veelgestelde Vragen
      </h2>
      <div className="space-y-6" data-id="element-81">
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-82">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-83">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-84" />
            <h3 className="font-bold" data-id="element-85">
              "Is er een specifiek moment waarop het kwartje valt?"
            </h3>
          </div>
          <div className="p-4" data-id="element-86">
            <p className="leading-relaxed" data-id="element-87">
              "Rond minuut 20 valt het kwartje," vertelt Amee. "Wanneer ik een
              aantal misvattingen over dominantie uit de wereld help, zie ik in
              de chat dat mensen plotseling begrijpen waarom hun aanpak niet
              werkte."
            </p>
            <p className="leading-relaxed mt-2" data-id="element-88">
              Voor Marcel was dit het keerpunt: "Toen begreep ik dat Luna en ik
              gewoon langs elkaar heen communiceerden. Zij probeerde
              samenwerking, ik dacht dat ze koppig was."
            </p>
          </div>
        </div>
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-89">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-90">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-91" />
            <h3 className="font-bold" data-id="element-92">
              "Waarom is dit {replaceWebinarWithLink('webinar')} gratis?"
            </h3>
          </div>
          <div className="p-4" data-id="element-93">
            <p className="leading-relaxed" data-id="element-94">
              Omdat het belangrijk is dat baasjes dit snappen geeft Amee het
              gratis webinar "Communiceren met je hond".
            </p>
            <p className="leading-relaxed mt-2" data-id="element-95">
              Natuurlijk heeft Amee ook verdere verdiepingscursussen voor wie
              meer wil leren, maar tijdens het webinar krijg je een stevige
              basis in wat David Mech werkelijk bedoelde.
            </p>
          </div>
        </div>
      </div>
    </section>;
};